
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";

export default defineComponent({
    name: "FilterSelection",
    computed: mapGetters({
        changedSlides: 'getChangedSlides',
        selectedChecks: 'getFilterSelection',
        cancelLabel: 'getCancelFilterLabel'
    }),
    methods: mapActions({
        clearFilter: 'CLEAR_FILTRATION',
    })
});
